const css = `@keyframes _panelIn_h4r3u_1 {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
._panel_h4r3u_11 {
  width: 380px;
  max-height: 480px;
  background: #1a1a1a;
  border-radius: 12px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(255, 255, 255, 0.08);
  overflow: hidden;
  z-index: 100001;
  animation: _panelIn_h4r3u_1 0.15s ease-out forwards;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  pointer-events: auto;
  display: flex;
  flex-direction: column;
}

._header_h4r3u_26 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

._titleWrapper_h4r3u_34 {
  display: flex;
  align-items: center;
  gap: 8px;
}

._title_h4r3u_34 {
  font-size: 13px;
  font-weight: 600;
  color: #fff;
}

._warningBadge_h4r3u_46 {
  font-size: 11px;
  padding: 2px 6px;
  border-radius: 4px;
  background: rgba(255, 149, 0, 0.2);
  color: #ff9500;
}

._generateButton_h4r3u_54 {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 5px 10px;
  background: rgba(175, 82, 222, 0.2);
  border: none;
  border-radius: 6px;
  color: #af52de;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.15s ease;
}
._generateButton_h4r3u_54:hover:not(:disabled) {
  background: rgba(175, 82, 222, 0.3);
}
._generateButton_h4r3u_54:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

._spinner_h4r3u_77 {
  width: 12px;
  height: 12px;
  border: 2px solid rgba(175, 82, 222, 0.3);
  border-top-color: #af52de;
  border-radius: 50%;
  animation: _spin_h4r3u_77 0.8s linear infinite;
}

@keyframes _spin_h4r3u_77 {
  to {
    transform: rotate(360deg);
  }
}
._controls_h4r3u_91 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

._viewToggle_h4r3u_99 {
  display: flex;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 6px;
  padding: 2px;
}

._toggleButton_h4r3u_106 {
  padding: 4px 12px;
  background: transparent;
  border: none;
  border-radius: 4px;
  color: rgba(255, 255, 255, 0.6);
  font-size: 12px;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
}
._toggleButton_h4r3u_106:hover {
  color: rgba(255, 255, 255, 0.8);
}
._toggleButton_h4r3u_106._active_h4r3u_119 {
  background: rgba(255, 255, 255, 0.15);
  color: #fff;
}

._actions_h4r3u_124 {
  display: flex;
  gap: 8px;
}

._actionButton_h4r3u_129 {
  padding: 4px 10px;
  background: transparent;
  border: none;
  border-radius: 4px;
  color: rgba(255, 255, 255, 0.6);
  font-size: 12px;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
}
._actionButton_h4r3u_129:hover {
  background: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.9);
}

._content_h4r3u_144 {
  flex: 1;
  overflow-y: auto;
  min-height: 0;
}
._content_h4r3u_144::-webkit-scrollbar {
  width: 6px;
}
._content_h4r3u_144::-webkit-scrollbar-track {
  background: transparent;
}
._content_h4r3u_144::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}
._content_h4r3u_144::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.3);
}

._empty_h4r3u_163 {
  padding: 32px 14px;
  text-align: center;
  color: rgba(255, 255, 255, 0.5);
  font-size: 12px;
}

._emptyIcon_h4r3u_170 {
  font-size: 28px;
  margin-bottom: 8px;
}

._scriptView_h4r3u_175 {
  padding: 12px;
}

._script_h4r3u_175 {
  font-family: "SF Mono", Monaco, "Consolas", monospace;
  font-size: 11px;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.85);
  white-space: pre-wrap;
  word-break: break-word;
  margin: 0;
}

._treeView_h4r3u_189 {
  padding: 8px;
}

._treeNode_h4r3u_193 {
  margin-left: 0;
}

._treeNodeContent_h4r3u_197 {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 8px;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.15s ease;
}
._treeNodeContent_h4r3u_197:hover {
  background: rgba(255, 255, 255, 0.06);
}
._treeNodeContent_h4r3u_197._hasWarning_h4r3u_209 {
  background: rgba(255, 149, 0, 0.08);
}
._treeNodeContent_h4r3u_197._hasWarning_h4r3u_209:hover {
  background: rgba(255, 149, 0, 0.12);
}

._roleIcon_h4r3u_216 {
  font-size: 10px;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  flex-shrink: 0;
}

._role_h4r3u_216 {
  font-size: 11px;
  font-weight: 500;
  color: #3c82f7;
  display: flex;
  align-items: center;
  gap: 2px;
}

._level_h4r3u_237 {
  font-size: 9px;
  background: rgba(60, 130, 247, 0.2);
  padding: 1px 4px;
  border-radius: 3px;
  margin-left: 2px;
}

._states_h4r3u_245 {
  font-size: 10px;
  color: #af52de;
  background: rgba(175, 82, 222, 0.15);
  padding: 1px 6px;
  border-radius: 3px;
}

._name_h4r3u_253 {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.7);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 160px;
}

._warning_h4r3u_46 {
  flex-shrink: 0;
  cursor: help;
}

._treeChildren_h4r3u_267 {
  margin-left: 16px;
  border-left: 1px solid rgba(255, 255, 255, 0.1);
  padding-left: 8px;
}

._footer_h4r3u_273 {
  padding: 8px 14px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

._stats_h4r3u_278 {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.5);
}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
export default {"panel":"_panel_h4r3u_11","panelIn":"_panelIn_h4r3u_1","header":"_header_h4r3u_26","titleWrapper":"_titleWrapper_h4r3u_34","title":"_title_h4r3u_34","warningBadge":"_warningBadge_h4r3u_46","generateButton":"_generateButton_h4r3u_54","spinner":"_spinner_h4r3u_77","spin":"_spin_h4r3u_77","controls":"_controls_h4r3u_91","viewToggle":"_viewToggle_h4r3u_99","toggleButton":"_toggleButton_h4r3u_106","active":"_active_h4r3u_119","actions":"_actions_h4r3u_124","actionButton":"_actionButton_h4r3u_129","content":"_content_h4r3u_144","empty":"_empty_h4r3u_163","emptyIcon":"_emptyIcon_h4r3u_170","scriptView":"_scriptView_h4r3u_175","script":"_script_h4r3u_175","treeView":"_treeView_h4r3u_189","treeNode":"_treeNode_h4r3u_193","treeNodeContent":"_treeNodeContent_h4r3u_197","hasWarning":"_hasWarning_h4r3u_209","roleIcon":"_roleIcon_h4r3u_216","role":"_role_h4r3u_216","level":"_level_h4r3u_237","states":"_states_h4r3u_245","name":"_name_h4r3u_253","warning":"_warning_h4r3u_46","treeChildren":"_treeChildren_h4r3u_267","footer":"_footer_h4r3u_273","stats":"_stats_h4r3u_278"};